import React from "react"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import { Control, UseFormSetValue } from "react-hook-form"
import { Form } from "sharedTypes"
import ManagePlusOnes from "../EditFormModalContent/EditFormModalSettings/ManagePlusOnes"
import MessagingSection from "../EditFormModalContent/EditFormModalSettings/Messaging"

type Props = {
  control: Control
  setValue: UseFormSetValue<any>
  form: Form
}

const PlusOneSettings = ({
  control, setValue, form,
}: Props) => (
  <>
    <SidePanelHeader>Plus-Ones</SidePanelHeader>
    <ManagePlusOnes control={control} form={form} setValue={setValue} />
    <MessagingSection form={form} />
  </>
)

export default PlusOneSettings
